import { AfterViewInit, Component } from "@angular/core";
import { AuthServiceService } from "src/app/shareModule/services/auth-service.service";
import { ToastrService } from 'ngx-toastr';
import { LocalServiceService } from "src/app/shareModule/services/local-service.service";

@Component({
    selector: 'app-biz-messages',
    templateUrl: './biz-messages.component.html',
    styleUrls: ['./biz-messages.component.scss'],
  })
  export class BizMessagesComponent  implements AfterViewInit{

    public messageToBeAdded: string = '';
    public isForLoginUserOnly: boolean = false;
    public messages = []

    
    constructor(private auth: AuthServiceService, private toastr: ToastrService, private local: LocalServiceService){

    }
  ngAfterViewInit(): void {
    this.getMessagesLists()
  }
    public deleteBizMessage(id){
      this.auth.deleteBizMessage(id).subscribe({
        next: (data)=>{
          this.toastr.success("Deleted!");
          this.getMessagesLists();
        },
        error: err =>{
          console.log(err);
          this.toastr.error("Unalbe to delete please try again latter")
        }
      })
    }

    public getMessagesLists(){
      const user = this.local.getUser();
      this.auth.getAllBizMessages(user?.id, false).subscribe({
        next: (data)=>{
          this.messages = data.data
          //console.log(this.messages)

        },
        error: (err)=>{
          console.error(err);
          this.toastr.error("Error something went while wrong fetching")
        }
      })
    }

    public addMessage(){
      this.auth.createBizMessage({
        message: this.messageToBeAdded,
        isForLoginUserOnly: this.isForLoginUserOnly
      }).subscribe({
        next: (data)=>{
          this.toastr.success("Added!")
          this.getMessagesLists()


        },
        error: (err)=>{
          console.error({err})
          this.toastr.error("Error")

        }
      })
      this.messageToBeAdded = '';
      this.isForLoginUserOnly = false

    }
  }